const CloseMenuOverlay = () => {
  return (document.getElementById("nav-menu-overlay").style.left = "-100%");
};

export default CloseMenuOverlay;
